export const regex = {
    mail: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    password: /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@$#^!%*?&])[^\s]{8,16}$/,
}